import React from 'react';
import './TermsAndConditions.css';
import { Helmet } from 'react-helmet';

const RefundPolicy = () => {

    return (
        <>

        <Helmet>
    <title>Refund Policy | SkillzVerse</title>

    <meta
        name="description"
        content="Read the SkillzVerse Refund Policy to understand course refund eligibility, cancellation terms, payment guidelines, refund process, and important policy conditions."
        />

    <meta
        name="keywords"
        content="Refund Policy,Refund and Cancellation Policy,Course Refund Policy,Online Course Refund,Cancellation Policy,Refund Terms"
    />

    <link
        rel="canonical"
        href="https://skillzverse.com/privacy-policy"
    />
</Helmet>
        <div className="terms-container">
            <h1>SkillzVerse Refund Policy</h1>

            <p>At SkillzVerse, we want to ensure your experience is smooth. If you’ve encountered any issues related to payment or course access, please refer to our refund policy below:</p>

            <section className="terms-section">
                <h2>1. Payment Confirmation</h2>
                <p>If you have made a payment but have not received course access, please verify that your payment has been successfully processed and debited from your account.</p>
            </section>

            <section className="terms-section">
                <h2>2. Payment Processing Issues</h2>
                <p>If the payment has not been received by the Company or there is a delay in processing, the Company is not responsible for any transaction issues. In such cases, please contact your bank or payment provider to resolve the issue.</p>
            </section>

            <section className="terms-section">
                <h2>3. Access to Courses</h2>
                <p>Access to the course will be granted only once the payment is successfully processed and received by the Company.</p>
            </section>

            <section className="terms-section">
                <h2>4. Course Deletion Refund Policy</h2>
                <p> If a course you purchased is deleted within 6 months of enrollment and you have not completed it, we will provide a 100% refund. If you have completed the course, we will offer a 50% refund within 6 months of purchase. The completion of a course is defined as having accessed and viewed a significant portion of the course content. Refund requests will be processed within 5-7 working days from the date of approval from our team.</p></section>

            <section className="terms-section">
                <h2>5. Payment Discrepancies</h2>
                <p>If the payment has been debited from your account but not received by the Company, please approach your bank or payment service provider for resolution before requesting a refund from us.</p>
            </section>

            <section className="terms-section">
                <h2>6. Third-Party Payment Providers</h2>
                <p>The Company is not responsible for any delays or errors caused by third-party financial institutions. However, we will assist you in resolving any payment-related issues promptly.</p>
            </section>

            <section className="terms-section">
                <h2>7. Contact Us for Assistance</h2>
                <p>If you have any questions or need assistance with payment issues, please <a href="/support" className="contact-link">reach out to us on our contact page</a>.</p>
            </section>

        </div>
        </>
    );
};

export default RefundPolicy;
